import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import BlockTitle from '../global/typography/BlockTitle';
import ItemCard from '../global/ItemCard';

const CardWrapper = styled.div`
  padding-right: 20px;
  padding-top: 20px;
  width: ${p => (p.product ? 25 : 20)}%;

  @media (max-width: ${props => props.theme.deviceWidth.tablet}) {
    width: 50%;
    max-width: none;
    min-width: 50%;
  }
`;

const InnerWrapper = styled.div`
  align-items: stretch;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  margin-right: 30px;
  @media (max-width: ${props => props.theme.deviceWidth.tablet}) {
    margin-right: 13px;
  }
`;

const RelatedWrapper = styled.div`
  padding-top: 50px;
  @media print {
    display: none;
  }
`;

const renderRelatedProducts = products =>
  products
    .slice(0, 4)
    .filter(product => Boolean(product))
    .map((product, i) => (
      <CardWrapper product key={i}>
        <ItemCard
          archived={product.archived}
          category={product.class.name}
          count={product.modelCount}
          countDesc="Model"
          description={
            product.description.length > 78
              ? `${product.description.substring(0, 75)}...`
              : product.description
          }
          image={product.image}
          path={`/products/${product.class.slug}/${product.slug}`}
          series={product.class.name}
        />
      </CardWrapper>
    ));

const renderRelatedDocuments = documents =>
  documents.slice(0, 4).map((doc, i) => (
    <CardWrapper key={i}>
      <ItemCard
        documentCategory="Document"
        description={doc.name}
        image={doc.image}
        path={doc.fileName}
        sub={
          doc.pageCount
            ? `${doc.pageCount} page${doc.pageCount !== 1 ? 's' : ''}`
            : ''
        }
      />
    </CardWrapper>
  ));

const RelatedList = ({ data = [], isProduct }) =>
  Array.isArray(data) && data.length > 0 ? (
    <RelatedWrapper>
      <BlockTitle>Related {isProduct ? 'Products' : 'Documents'}</BlockTitle>
      <InnerWrapper>
        {isProduct ? renderRelatedProducts(data) : renderRelatedDocuments(data)}
      </InnerWrapper>
    </RelatedWrapper>
  ) : null;

RelatedList.propTypes = {
  data: PropTypes.array,
  isProduct: PropTypes.bool
};

export default RelatedList;
